var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatsBlog({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 80,
    viewBox: "0 0 72 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.24 0H52.764C65.12 0 72 7.12001 72 19.32V60.64C72 73.04 65.12 80 52.764 80H19.24C7.08 80 0 73.04 0 60.64V19.32C0 7.12001 7.08 0 19.24 0ZM20.32 18.64V18.6H32.276C34 18.6 35.4 20 35.4 21.716C35.4 23.48 34 24.88 32.276 24.88H20.32C18.596 24.88 17.2 23.48 17.2 21.76C17.2 20.04 18.596 18.64 20.32 18.64ZM20.32 42.96H51.68C53.4 42.96 54.8 41.56 54.8 39.84C54.8 38.12 53.4 36.716 51.68 36.716H20.32C18.596 36.716 17.2 38.12 17.2 39.84C17.2 41.56 18.596 42.96 20.32 42.96ZM20.32 61.24H51.68C53.276 61.08 54.48 59.716 54.48 58.12C54.48 56.48 53.276 55.12 51.68 54.96H20.32C19.12 54.84 17.96 55.4 17.32 56.44C16.68 57.44 16.68 58.76 17.32 59.8C17.96 60.8 19.12 61.4 20.32 61.24Z",
    fill: "url(#paint0_linear_4264_2718)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4264_2718",
    x1: -20.1632,
    y1: 0,
    x2: -20.1632,
    y2: 124.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsBlog);
export default __webpack_public_path__ + "static/media/stats-blog.fe177d97fd2da40628792bdcaf8cc663.svg";
export { ForwardRef as ReactComponent };